const elevationStyles = {
  none: {},
  flat: { boxShadow: 'border' },
  small: { boxShadow: 'smallest' },
  medium: { boxShadow: 'medium' },
  large: { boxShadow: 'overlay' },
};

const cardElevations = {
  ...elevationStyles,

  // Numeric aliases:
  0: elevationStyles.none,
  1: elevationStyles.flat,
  2: elevationStyles.small,
  3: elevationStyles.medium,
  4: elevationStyles.large,
};

// These styles are mixed into the basic card styles when the card is hovered.
const hoverElevationStyles = {
  flat: {
    transition: 'boxShadow',
    ':hover:is(a, button)': { boxShadow: 'medium' },
  },
};

const hoverElevations = {
  ...hoverElevationStyles,

  // Numeric aliases:
  0: elevationStyles.none,
  1: elevationStyles.flat,
  2: elevationStyles.small,
  3: elevationStyles.medium,
  4: elevationStyles.large,
};

const cardVariants = {
  default: cardElevations,
  hover: Object.fromEntries(
    Object.entries(cardElevations).map(([key, value]) => [
      key,
      { ...value, ...hoverElevations[key] },
    ])
  ),
};

export default cardVariants;

/** @typedef {keyof typeof cardElevations} CardElevation */
/** @typedef {keyof typeof cardVariants} CardVariant */
